import { getAppState } from "../state";
import { i18n } from "./i18nService";

import { getSpSportsPackageDisplayName, getStarzplayPackageDisplayName } from './sportPackageService'
import packageJson from "../../package.json";

const appVersionQueryParameter = `?version=${packageJson?.version}`;

export default function getBrands(type, category) {
  let base = [];
  // added new flag isCustomAddon to manage addons WBIGS-2049
  let allAddons = getAppState().subscriptions?.filter(data => !(data?.configuration?.isMainPackage) && !data?.configuration.isCustomAddon)  || [];
  let activeAddons = [];
  var inActiveBase = [];
  if (type === "ACTIVE" && getAppState().userLogged) {
    // show all available brands and addons but with lock.

    getAppState().addons.length > 0 &&
      (activeAddons = allAddons.filter(ar =>
        getAppState().addons.find(rm => rm.name === ar.name && ar.place === rm.place && rm.status === "Active")
      ));
    let catalogItems = [...activeAddons];
    if (getAppState().userAccountStatus === "Active") {
      base = getAppState().subscriptions?.filter(data => data?.configuration?.isMainPackage);
      catalogItems = [...(base && base.length > 0 ? base[0].brands : [] ), ...catalogItems].sort((a, b) => a.displayOrder - b.displayOrder);
    }
    if (category === "ListBrandsActive") {
      catalogItems = processGridFeeds(catalogItems, category);
    }

    return catalogItems;
  } else if (type === "IN_ACTIVE") {
    // show all available brands and addons but with lock.
    getAppState().addons?.length > 0 &&
      (allAddons = allAddons.filter(
        ar => !getAppState().addons.find(rm => rm.name === ar.name && ar.place === rm.place && rm.status === "Active")
      ));
    getAppState().userAccountStatus !== "Active" &&
      (inActiveBase = getAppState().subscriptions?.filter(data => data?.configuration?.isMainPackage));
    getAppState().userAccountStatus !== "Active" &&
      inActiveBase &&
      inActiveBase[0].brands.map(module => (module.isBrand = true));
    let catalogItems = [...(inActiveBase && inActiveBase.length > 0 ? inActiveBase[0].brands : []), ...allAddons].sort(
      (a, b) => a.displayOrder - b.displayOrder
    );

    if (category === "ListBrandsDisabled") {
      catalogItems = processGridFeeds(catalogItems, category);
    }
    return catalogItems;
  }
  return [];
}

function processGridFeeds(feeds, category) {
  return feeds.map((feed, index) => {
    const versionedImageUrl = `${feed?.configuration?.logoDefaultPNG}${appVersionQueryParameter}`
    // FIXME Shouldn't this be done in SDK or Middleware?
    if (category === "ListBrandsDisabled") {
      feed["icon"] = "lock";
      feed.itemIndex = index;
      feed["imageUrl"] = versionedImageUrl
        ? versionedImageUrl
        : versionedImageUrl;
      feed["posterUrl"] = feed?.configuration?.backgroundImagePNG
        ? feed?.configuration?.backgroundImagePNG
        : feed?.configuration?.backgroundImageJPG;
      feed["title"] = feed.name;
      feed["infoText"] = !feed?.configuration?.isStandalone ? (feed?.configuration?.isSports && feed?.configuration?.isIncludedInSportsPackage) ? i18n.get("pages.brands.partOf", getSpSportsPackageDisplayName()) : feed?.isBrand ? i18n.get("pages.brands.partOf", getStarzplayPackageDisplayName()) : null : null;
    } else {
      feed["icon"] = null;
      feed["infoText"] = null;
      feed.itemIndex = index;
      feed["imageUrl"] = versionedImageUrl
        ? versionedImageUrl
        : versionedImageUrl;
      feed["posterUrl"] = feed?.configuration?.backgroundImagePNG
        ? feed?.configuration?.backgroundImagePNG
        : feed?.configuration?.backgroundImageJPG;
      feed["title"] = feed.name;
    }
    return feed;
  });
}

let savedFocuInfo = null;
export const saveFocusInfo = from => {
  savedFocuInfo = from;;
};

export const getSavedFocusInfo = () => {
  return savedFocuInfo;
};

export const removeSavedFocusInfo = () => {
  savedFocuInfo = null;
};
